var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.688,
    height: 32.086,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2755",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3010",
    d: "M26.364 4.941l-9.024.175a1.224 1.224 0 00.047 2.447l6.057-.117-18.017 18.64a1.224 1.224 0 101.76 1.701l18.017-18.64.09 6.058a1.224 1.224 0 002.447-.035l-.129-9.026a1.225 1.225 0 00-1.248-1.203z",
    fill: "#1c2d41"
  }))));
};
export default SvgArrow;